module.exports = __webpack_public_path__ + "static/media/er.976db2b7.svg";